export default "__VITE_ASSET__BMltiqsZ__"